import Separator from 'components/Separator';
import './infoDetails.scss'

const InfoDetails = ({ title, items }) => {
    return (
        <div className='info-details-container'>
            <p className='header'>{title}</p>
            <Separator height={16} />
            <div className='items'>
                {
                    items.map((item, index) => {
                        return (
                            <div className='item' key={index}>
                                <p>{item}</p>
                            </div>
                        )
                    })
                }
            </div>
        </div>

    )
}


export default InfoDetails;